// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"28":"ce12fe26a52e24c0ef06","57":"70cd82813f81451c9806","883":"aee200edf3d451b76d12","952":"931b548fa3d92da30642"}[chunkId] + "/css/" + {"28":"ShiftPage","57":"index","883":"Staff","952":"TestSettings"}[chunkId] + ".css";
};